import { render, staticRenderFns } from "./td-tertiary.vue?vue&type=template&id=19f3b086&scoped=true&"
import script from "./td-tertiary.vue?vue&type=script&lang=js&"
export * from "./td-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f3b086",
  null
  
)

export default component.exports